export const maijaBackgroundSecondary = "#f5f5f5";
export const actionFabColor = "#f5f5f5";
export const appBarTextInactiveLight = "#C5C5C5";
export const appBarTextInactiveDark = "#4C4C4C";
export const defaultBorderColor = "grey.300";
